import type { AdminUser } from './types';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const TOKEN_KEY = 'hola_admin_token';
const ADMIN_KEY = 'hola_admin_user';

// --- Authentication ---

export async function signIn(email: string, password: string): Promise<{ user: AdminUser | null; error: string | null }> {
  try {
    const res = await fetch(`${API_BASE}/api/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();

    if (!res.ok) {
      return { user: null, error: data.error || 'Invalid credentials' };
    }

    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem(ADMIN_KEY, JSON.stringify(data.admin));

    return { user: data.admin as AdminUser, error: null };
  } catch {
    return { user: null, error: 'Unable to connect to server. Please try again.' };
  }
}

export function signOut(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getCurrentAdmin(): AdminUser | null {
  const stored = localStorage.getItem(ADMIN_KEY);
  if (!stored) return null;
  try {
    // Check token expiry (JWT payload is base64 in the middle segment)
    const token = getToken();
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp * 1000 < Date.now()) {
      signOut();
      return null;
    }
    return JSON.parse(stored) as AdminUser;
  } catch {
    signOut();
    return null;
  }
}

export function getAuthHeaders(): Record<string, string> {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
